/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum VaultMediaType {
    ALL = 'all',
    VIDEO = 'video',
    PHOTO = 'photo',
    GIF = 'gif',
    AUDIO = 'audio',
    UNKNOWN = 'unknown',
}
